<template>
    <div>
        <!-- 基本信息 -->
        <div class="inputList">

            <labelInput :outInput="newform.name" :spanRequired="true" normalPlace="请输入"
                        @inputChange="labelInput($event,'name')"
                        spanTitle="工法名称" :spanWidth="spanWidth" componentWidth="86.5%">
            </labelInput>

            <div style="display: flex;flex-wrap: wrap;margin-top: 20px;">

                <normalSelect   :spanRequired="true"
                                pelaceHolder='请选择'
                                :outInput="newform.category"
                                :spanWidth="spanWidth" @selectCode="typeThreeInput($event,'1')"
                                :dataList="installList2" componentWidth="500px" spanTitle="类别">
                </normalSelect>


                <div data-v-7f245221="" class="labelSelect" style="width: 500px;">
                    <span class="innerSpan" style="color: rgb(0, 0, 0); font-size: 14px; width: 180px;">
                        <span style="color: red;">*&nbsp;</span>专业分类:</span>
                    <div class="innerP">
                    <div style="width: 99%;">
                        <el-select clearable  v-model="newform.major_category"  placeholder="请选择" >

                            <el-option
                                    v-for="item in installList35"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code">
                            </el-option>
                        </el-select>


                        <!--<div class="el-select selectInner">
                            <div class="el-input el-input&#45;&#45;suffix">
                                <input type="text" readonly="readonly" autocomplete="off" placeholder="请选择" class="el-input__inner">
                               <span class="el-input__suffix">
                                    <span class="el-input__suffix-inner"><i class="el-select__caret el-input__icon el-icon-arrow-up"></i></span>
                                </span>
                            </div>
                        </div>-->
                    </div>
                    </div>
                </div>

               <!-- <normalSelect   :spanRequired="true"
                                pelaceHolder='请选择'
                                :spanWidth="spanWidth" @selectCode="typeThreeInput($event,'2')"
                                :dataList="installList31" componentWidth="500px" spanTitle="专业分类">
                </normalSelect>-->
            </div>


            <div style="display: flex;flex-wrap: wrap;margin-top: 20px;">

                <normalSelect   :spanRequired="true"
                                pelaceHolder='请选择'
                                :outInput="newform.recommend_area"
                                :spanWidth="spanWidth" @selectCode="typeThreeInput($event,'3')"
                                :dataList="installList1" componentWidth="500px" spanTitle="申报推荐地区">
                </normalSelect>

                <normalSelect   :spanRequired="true"
                                pelaceHolder='请选择注册地'
                                :outInput="newform.register_area"
                                :spanWidth="spanWidth" @selectCode="typeThreeInput($event,'4')"
                                :dataList="installList4" componentWidth="500px" spanTitle="企业注册地">
                </normalSelect>
            </div>


            <div style="display: flex;flex-wrap: wrap;margin-top: 20px;">

                <normalSelect   :spanRequired="true"
                                pelaceHolder='请选择'
                                :outInput="newform.is_pro"
                                :spanWidth="spanWidth" @selectCode="typeThreeInput($event,'5')"
                                :dataList="installList5" componentWidth="500px" spanTitle="是否为升级版工法">
                </normalSelect>

                <normalSelect   :spanRequired="true"
                                pelaceHolder='请选择'
                                :outInput="newform.has_patent"
                                :spanWidth="spanWidth" @selectCode="typeThreeInput($event,'6')"
                                :dataList="installList5" componentWidth="500px" spanTitle="是否包含专利">
                </normalSelect>
            </div>


            <p class="view_head midflex">
                主要完成人

                <!-- 按钮 -->
                <span class="newAddBtn">
                    <!--<el-button type="primary" @click="addInstall1" >增行</el-button>-->

                    <el-button
                            size="small"

                            icon="el-icon-plus"
                            @click="addInstall1"
                    ></el-button>

                      <el-button
                              size="small"
                              icon="el-icon-minus"
                              @click="deleteList1()"
                      ></el-button>
                </span>
            </p>

            <labelInput :outInput="newform.complete_collect" :spanRequired="true" normalPlace="请输入"
                        @inputChange="labelInput($event,'complete_collect')"
                        spanTitle="主要完成人汇总" :spanWidth="spanWidth" componentWidth="86.5%">
            </labelInput>


            <div style="display: flex;flex-wrap: wrap;margin-top: 20px;" v-for="(i,index) in completeManList">
               <!-- <labelInput :spanRequired="true" normalPlace="请输入"
                            @inputChange="typeThreeInput1($event,1,index)"
                            :outInput="i.username"
                            spanTitle="姓名" :spanWidth="spanWidth" componentWidth="500px">
                </labelInput>-->

                <div class="labelInput" style="width:500px">
                    <span style="color: rgb(0, 0, 0); font-size: 14px; width: 180px;" class="innerSpan">
                        <span style="color: red;">*&nbsp;</span>
                        姓名:
                    </span>
                    <div class="innerP" style="width: auto; font-size: 14px;">
                        <el-input placeholder="请输入" v-model="i.username"
                                  @change="typeThreeInput1($event,1,index)"></el-input>
                    </div>
                </div>

            <!--    <labelInput
                        :outInput="i.unit"
                        :spanRequired="true" normalPlace="请输入"
                            @inputChange="typeThreeInput1($event,2,index)"
                            spanTitle="工作单位" :spanWidth="spanWidth" componentWidth="500px"
                            >
                </labelInput>-->


                <div class="labelInput" style="width:500px">
                    <span style="color: rgb(0, 0, 0); font-size: 14px; width: 180px;" class="innerSpan">
                            <span style="color: red;">*&nbsp;</span>
                            工作单位:
                        </span>
                    <div class="innerP" style="width: auto; font-size: 14px;">
                        <el-input placeholder="请输入" v-model="i.unit"
                                  @change="typeThreeInput1($event,2,index)"></el-input>
                    </div>
                </div>

               <!-- <labelInput
                        :outInput="i.post"
                        normalPlace="请输入"
                            @inputChange="typeThreeInput1($event,3,index)"
                            spanTitle="职务" :spanWidth="spanWidth" componentWidth="500px"
                            >
                </labelInput>-->

                <div class="labelInput" style="width:500px">
                    <span style="color: rgb(0, 0, 0); font-size: 14px; width: 180px;" class="innerSpan">

                            职务:
                        </span>
                    <div class="innerP" style="width: auto; font-size: 14px;">
                        <el-input placeholder="请输入" v-model="i.post"
                                  @change="typeThreeInput1($event,3,index)"></el-input>
                    </div>
                </div>



               <!-- <labelInput
                        :outInput="i.title"
                        normalPlace="请输入"
                            @inputChange="typeThreeInput1($event,4,index)"
                            spanTitle="职称" :spanWidth="spanWidth" componentWidth="500px"
                            >
                </labelInput>-->

                <div class="labelInput" style="width:500px">
                    <span style="color: rgb(0, 0, 0); font-size: 14px; width: 180px;" class="innerSpan">

                            职称:
                        </span>
                    <div class="innerP" style="width: auto; font-size: 14px;">
                        <el-input placeholder="请输入" v-model="i.title"
                                  @change="typeThreeInput1($event,4,index)"></el-input>
                    </div>
                </div>


              <!--  <labelInput
                        :outInput="i.phone"
                        :spanRequired="true" normalPlace="请输入"
                            @inputChange="typeThreeInput1($event,5,index)"
                            spanTitle="电话" :spanWidth="spanWidth" componentWidth="500px"
                          >
                </labelInput>
-->

                <div class="labelInput" style="width:500px">
                    <span style="color: rgb(0, 0, 0); font-size: 14px; width: 180px;" class="innerSpan">
                            <span style="color: red;">*&nbsp;</span>
                            电话:
                        </span>
                    <div class="innerP" style="width: auto; font-size: 14px;">
                        <el-input placeholder="请输入" v-model="i.phone"
                                  @change="typeThreeInput1($event,5,index)"></el-input>
                    </div>
                </div>


            </div>

            <!-- 主要经营管理指标统计 -->
            <p class="view_head midflex">
                工法应用工程情况
                <!-- 按钮 -->
               <!-- <span class="newAddBtn">
                    <el-button type="primary" @click="addInstall2">增行</el-button>
                </span>
-->
                <el-button
                        size="small"

                        icon="el-icon-plus"
                        @click="addInstall2"
                ></el-button>

                <el-button
                        size="small"
                        icon="el-icon-minus"
                        @click="deleteList2()"
                ></el-button>

            </p>


            <div style="margin-bottom: 10px" v-for="(i2,index) in applicationList" :key="index" v-if="applicationList.length">



                <div class="labelInput" style="width:98%">
                    <span style="color: rgb(0, 0, 0); font-size: 14px; width: 180px;" class="innerSpan">
                        <span style="color: red;">*&nbsp;</span>
                        工程名称:
                    </span>
                    <div class="innerP" style="width: auto; font-size: 14px;">
                        <el-input placeholder="请输入" v-model="i2.project_name"  :maxlength=60
                                  @change="typeThreeInput2($event,1,index)"></el-input>
                    </div>
                </div>


              <!--  <labelInput

                        :spanRequired="true" normalPlace="请输入"
                            @inputChange="typeThreeInput2($event,1,index)"
                            spanTitle="工程名称" :spanWidth="spanWidth" componentWidth="500px"
                           >
                </labelInput>-->


                <div style="display: flex;flex-wrap: wrap;margin-top: 20px;">

                  <div  class="labelInput" style="width:500px">
                    <span style="color: rgb(0, 0, 0); font-size: 14px; width: 180px;" class="innerSpan">
                            <span style="color: red;">*&nbsp;</span>
                            开竣工时间:
                    </span>
                    <el-date-picker v-model="i2.start_work"  value-format="yyyy-MM-dd"
                                    style="width: 240px;margin-left: 18px;margin-right: 25px;" type="daterange" start-placeholder="开工日期"
                                    end-placeholder="竣工日期">
                    </el-date-picker>
                  </div>

<!--                    <div class="labelInput" style="width:500px">
                        <span style="color: rgb(0, 0, 0); font-size: 14px; width: 180px;" class="innerSpan">
                            <span style="color: red;">*&nbsp;</span>
                            开竣工时间:
                        </span>
                        <div class="innerP" style="width: auto; font-size: 14px;">
                            <el-input placeholder="请输入" v-model="i2.start_work"
                                      @change="typeThreeInput2($event,2,index)"
                            >

                            </el-input>
                        </div>
                    </div>-->

                 <!--   <labelInput
                            :outInput="i2.start_work"
                            :spanRequired="true" normalPlace="请输入"
                                 @inputChange="typeThreeInput2($event,2,index)"
                                spanTitle="开竣工时间"
                                 :spanWidth="spanWidth"
                                 componentWidth="500px"
                                >
                    </labelInput>-->


                  <!--  <normalSelect
                            :outInput="i2.where"
                            :spanRequired="true"
                                    pelaceHolder='工程所在地区'
                                    :spanWidth="spanWidth"
                                    @selectCode="typeThreeInput($event,'11',index)"
                                    :dataList="installList4"
                                    componentWidth="500px"
                                    spanTitle="工程所在地区"
                    >
                    </normalSelect>
-->

                    <div class="labelSelect" style="width:500px">
                        <span style="color:#000;fontSize:14px;width: 180px" class="innerSpan">
                            <span style="color: red;" >*&nbsp;</span>
                            工程所在地区:
                        </span>
                        <div class="innerP">
                            <div v-for="(select,index) in installList4" :key="index" style="width: 99%">
                                <el-select v-model="i2.where" placeholder="请选择" class="selectInner">
                                    <el-option v-for="(item,index) in select" :key="index" :label="item.name" :value="item.code">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>


                </div>

                <div class="labelInput" style="width: 800px;">
                    <span class="innerSpan" style="color: rgb(0, 0, 0); font-size: 14px; width: 180px;">
                        <span style="color: red;">*&nbsp;</span>
                		工程照片:
                	</span>

                    <div class="innerdialog_list" style="margin-left: 11px">
                       <!--<p class="listP">选择文件：</p>-->
                        <div class="list_center" >
                          <div class="inner_upload" v-for="(item,index2) in fileList[index].imgUrl" :key="index2" >
                                <p>{{item.name}}</p>
                                <img src="../../../assets/img/login/cuowu.png" @click="deleteUpload(index,index2)">
                            </div>
                        </div>
                        <el-upload ref="upload"
                                   style="display: inline-block;"
                                   action=""

                                   :accept="acceptList"
                                   :before-upload="
                                      (file) => {
                                        return beforeAvatarUpload(file, index)
                                      }
                                    "
                                   :http-request="httpRequest"
                                   :show-file-list="false">

                            <span class="specilSpan" style="margin-left: 10px">选择文件</span>

                        </el-upload>
                    </div>
                </div>

                <!--<div>
                    <el-button style="width: 70px;height: 40px;margin-left: 10px;margin-bottom: 10px"
                               @click="deleteList2(index)" v-if="index != 0">删
                    </el-button>
                </div>-->

            </div>

            <!-- 主要经营管理指标统计 -->
            <p class="view_head midflex">工法内容简介</p>

            <div>
                <labelInput :outInput="newform.content1"
                            :spanRequired="true"
                            normalPlace="请输入"
                            @inputChange="labelInput($event,'content1')"
                            spanTitle="工法关键技术名称、组织审定单位和时间"
                            :spanWidth="spanWidth"
                            :maxLimit=100
                            componentWidth="950px"
                            specilType="textarea"

                >
                </labelInput>

                <labelInput :outInput="newform.content2"  normalPlace="请输入"
                            @inputChange="labelInput($event,'content2')"
                            spanTitle="工法关键技术获科技成果奖励的情况" :spanWidth="spanWidth"
                            :maxLimit=100
                            specilType="textarea"
                            componentWidth="950px"
                >
                </labelInput>

                <labelInput :outInput="newform.content3"  normalPlace="请输入"
                            @inputChange="labelInput($event,'content3')"
                            spanTitle="工法形成企业技术标准情况" :spanWidth="spanWidth"
                            :maxLimit=100
                            specilType="textarea"
                            componentWidth="950px"
                >
                </labelInput>

                <labelInput :outInput="newform.content4"  normalPlace="请输入"
                            @inputChange="labelInput($event,'content4')"
                            spanTitle="升级版工法原工法编号、名称、完成单位及批准文号（升级版工法填写此栏）" :spanWidth="spanWidth"
                            :maxLimit=100
                            specilType="textarea"
                            componentWidth="950px"
                >
                </labelInput>

                <labelInput :outInput="newform.content5"  normalPlace="请输入"
                            @inputChange="labelInput($event,'content5')"
                            spanTitle="工法摘要（300字以内）" :spanWidth="spanWidth"
                            :maxLimit=300
                            :autosize="{ minRows: 6}"
                            specilType="textarea"
                            componentWidth="950px"
                >
                </labelInput>


                <labelInput :outInput="newform.content6" normalPlace="请输入"
                            @inputChange="labelInput($event,'content6')"
                            spanTitle="工法关键词" :spanWidth="spanWidth"
                            :maxLimit=100
                            specilType="textarea"
                            componentWidth="950px"
                >
                </labelInput>

                <labelInput :outInput="newform.content7"  normalPlace="请输入"
                            @inputChange="labelInput($event,'content7')"
                            spanTitle="工法内容简述" :spanWidth="spanWidth"
                            :maxLimit=300
                            :rows="6"
                            specilType="textarea"
                            componentWidth="950px"
                >
                </labelInput>

                <labelInput :outInput="newform.content8"  normalPlace="请输入"
                            @inputChange="labelInput($event,'content8')"
                            spanTitle="关键技术及保密点" :spanWidth="spanWidth"
                            :maxLimit=100
                            specilType="textarea"
                            componentWidth="950px"
                >
                </labelInput>


                <labelInput :outInput="newform.content9"  normalPlace="请输入"
                            @inputChange="labelInput($event,'content9')"
                            spanTitle="技术水平和技术难度（包括与省内外同类技术水平比较）" :spanWidth="spanWidth"
                            :maxLimit=100
                            specilType="textarea"
                            componentWidth="950px"
                >
                </labelInput>

                <labelInput :outInput="newform.content10"  normalPlace="请输入"
                            @inputChange="labelInput($event,'content10')"
                            spanTitle="工程应用情况及推广应用前景" :spanWidth="spanWidth"
                            :maxLimit=100
                            specilType="textarea"
                            componentWidth="950px"
                >
                </labelInput>

                <labelInput :outInput="newform.content11" normalPlace="请输入"
                            @inputChange="labelInput($event,'content11')"
                            spanTitle="经济效益或社会效益（包括节能和环保效益）" :spanWidth="spanWidth"
                            :maxLimit=100
                            specilType="textarea"
                            componentWidth="950px"
                >
                </labelInput>
            </div>


            <!-- 主要经营管理指标统计 -->
            <p class="view_head midflex">
                涉及专利的工法应填写下列内容
                <!-- 按钮 -->
               <!-- <span class="newAddBtn">
                    <el-button type="primary" @click="addInstall3">增行</el-button>
                </span>-->

                <el-button
                        size="small"

                        icon="el-icon-plus"
                        @click="addInstall3"
                ></el-button>

                <el-button
                        size="small"
                        icon="el-icon-minus"
                        @click="deleteList3()"
                ></el-button>


            </p>

            <div style="margin-bottom: 10px" v-for="(i3,index) in patentList">
                <div style="display: flex;flex-wrap: wrap;margin-top: 20px;">
                   <!-- <labelInput normalPlace="请输入"
                                :outInput="i3.patent_name"

                                @inputChange="typeThreeInput4($event,1,index)"
                                spanTitle="专利名称" :spanWidth="spanWidth" componentWidth="500px"
                    >
                    </labelInput>-->

                    <div class="labelInput" style="width:500px">
                        <span style="color: rgb(0, 0, 0); font-size: 14px; width: 180px;" class="innerSpan">

                            专利名称:
                        </span>
                        <div class="innerP" style="width: auto; font-size: 14px;">
                            <el-input placeholder="请输入" v-model="i3.patent_name"
                                      @change="typeThreeInput4($event,1,index)"></el-input>
                        </div>
                    </div>

                   <!-- <labelInput  normalPlace="请输入"
                                 :outInput="i3.patent_num"
                                 @inputChange="typeThreeInput4($event,2,index)"
                                spanTitle="专利号及专利有效期" :spanWidth="spanWidth" componentWidth="500px"
                    >
                    </labelInput>-->


                    <div class="labelInput" style="width:500px">
                        <span style="color: rgb(0, 0, 0); font-size: 14px; width: 180px;" class="innerSpan">

                            专利号及专利有效期:
                        </span>
                        <div class="innerP" style="width: auto; font-size: 14px;">
                            <el-input placeholder="请输入" v-model="i3.patent_num"
                                      @change="typeThreeInput4($event,2,index)"></el-input>
                        </div>
                    </div>


                    <!--<labelInput   normalPlace="请输入"
                                  :outInput="i3.patent_man_name"
                                  @inputChange="typeThreeInput4($event,3,index)"
                                spanTitle="专利权人姓名" :spanWidth="spanWidth" componentWidth="500px"
                    >
                    </labelInput>-->

                    <div class="labelInput" style="width:500px">
                        <span style="color: rgb(0, 0, 0); font-size: 14px; width: 180px;" class="innerSpan">

                            专利权人姓名:
                        </span>
                        <div class="innerP" style="width: auto; font-size: 14px;">
                            <el-input placeholder="请输入" v-model="i3.patent_man_name"
                                      @change="typeThreeInput4($event,3,index)"></el-input>
                        </div>
                    </div>


                 <!--   <normalSelect   :spanRequired="false"
                                    :outInput="i3.patent_enp"
                                    pelaceHolder='企业专利或职工专利'
                                    :spanWidth="spanWidth"
                                    @selectCode="typeThreeInput($event,'12',index)"
                                    :dataList="installList7"
                                    componentWidth="500px"
                                    spanTitle="企业专利或职工专利">
                    </normalSelect>-->


                    <div class="labelSelect" style="width:500px">
                        <span style="color:#000;fontSize:14px;width: 180px" class="innerSpan">

                            企业专利或职工专利:
                        </span>
                        <div class="innerP">
                            <div v-for="(select,index) in installList7" :key="index" style="width: 99%">
                                <el-select v-model="i3.patent_enp" placeholder="请选择" class="selectInner"

                                >
                                    <el-option v-for="(item,index) in select" :key="index" :label="item.name" :value="item.code">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>



                </div>
                <!--<labelInput
                            normalPlace="请输入"
                            :outInput="i3.range"
                            @inputChange="typeThreeInput4($event,4,index)"
                            spanTitle="许可使用（有偿或无偿）范围、期限、权限"
                            :spanWidth="spanWidth" componentWidth="500px"
                >
                </labelInput>-->

                <div class="labelInput" style="width:500px">
                        <span style="color: rgb(0, 0, 0); font-size: 14px; width: 180px;" class="innerSpan">

                            许可使用（有偿或无偿）范围、期限、权限:
                        </span>
                    <div class="innerP" style="width: auto; font-size: 14px;">
                        <el-input placeholder="请输入" v-model="i3.range"
                                  :maxlength=60
                                  @change="typeThreeInput4($event,4,index)"></el-input>
                    </div>
                </div>

                <!--<div>
                    <el-button style="width: 70px;height: 40px;margin-left: 10px;margin-bottom: 10px"
                               @click="deleteList3 (index)" v-if="index != 0">删
                    </el-button>
                </div>-->
            </div>


            <!--<div style="margin:10px auto;">
                <el-button type="primary" @click="basicInfo">下一步</el-button>
            </div>-->

        </div>
    </div>
</template>

<script>
    import labelInput from '../../../components/table/labelInput.vue'
    import normalPicker from '../../../components/table/normalPicker.vue'

    import normalSelect from '../../././../components/table/normalSelect.vue'

    import {

        getWinningInfo

    } from '../../../api/moudles/manager.js'


    import {
        client
    } from '@/libs/oss.js'

    import {
        API_DOMAIN
    } from '../../../api/api.js'


    import {saveQua, setAdvanceInfoGF, setBasicProgram} from "../../../api/moudles/manager";
    import labelText from '../../../components/table/labelText.vue'

    export default {
        data() {
            return {
                project_app_num2:'',
                fileList: [
                    {
                        imgUrl:[

                        ]
                    },
                    {
                        imgUrl:[

                        ]
                    }
                ],
                spanWidth: '180px',
                acceptList:'',
                mode: 'muban',

                completeManList:[{}],
                applicationList:[{},{}],
                patentList:[{}],

                uploadIndex:'',
                isEdit:'',

                newform:{

                    name:'',
                    category:'',
                    major_category:'',
                    recommend_area:'',
                    register_area:'',
                    is_pro:'',
                    has_patent:'',

                    content1: '',
                    content2: '',
                    content3: '',
                    content4: '',
                    content5: '',
                    content6: '',
                    content7: '',
                    content8: '',
                    content9: '',
                    content10: '',
                    content11: '',
                },
                addList:[],

                installList5:[
                    [{
                        name: '是',
                        code: '1'
                    }, {
                        name: '否',
                        code: '0'
                    }
                    ]
                ],

                installList7:[
                    [{
                        name: '企业专利',
                        code: '企业专利'
                    }, {
                        name: '职工专利',
                        code: '职工专利'
                    }
                    ]
                ],


                installList2:[
                    [{
                        name: '房屋建筑工程',
                        code: '房屋建筑工程'
                    }, {
                        name: '市政公用工程',
                        code: '市政公用工程'
                    }, {
                        name: '机电安装工程',
                        code: '机电安装工程'
                    },
                    {
                        name: '行业工法（申请认定）',
                        code: '行业工法（申请认定）'
                    },
                    ]
                ],
                installList35:[],
                installList4:[
                    [{
                        name: '福州市',
                        code: '福州市'
                    }, {
                        name: '厦门市',
                        code: '厦门市'
                    }, {
                        name: '泉州市',
                        code: '泉州市'
                    },
                        {
                            name: '漳州市',
                            code: '漳州市'
                        }, {
                        name: '莆田市',
                        code: '莆田市'
                    },{
                        name: '龙岩市',
                        code: '龙岩市'
                    },{
                        name: '三明市',
                        code: '三明市'
                    },{
                        name: '南平市',
                        code: '南平市'
                    },{
                        name: '宁德市',
                        code: '宁德市'
                    },{
                        name: '平潭综合实验区',
                        code: '平潭综合实验区'
                    },{
                        name: '福建省外',
                        code: '福建省外'
                    },

                    ]
                ],

                installList1:[
                    [{
                        name: '福州市',
                        code: '福州市'
                    }, {
                        name: '厦门市',
                        code: '厦门市'
                    }, {
                        name: '泉州市',
                        code: '泉州市'
                    },
                        {
                            name: '漳州市',
                            code: '漳州市'
                        }, {
                        name: '莆田市',
                        code: '莆田市'
                    },{
                        name: '龙岩市',
                        code: '龙岩市'
                    },{
                        name: '三明市',
                        code: '三明市'
                    },{
                        name: '南平市',
                        code: '南平市'
                    },{
                        name: '宁德市',
                        code: '宁德市'
                    },{
                        name: '平潭综合实验区',
                        code: '平潭综合实验区'
                    },{
                        name: '直属申报',
                        code: '直属申报'
                    },

                    ]
                ],

                installList31:[
                    {
                        name: '地基与基础',
                        code: '地基与基础'
                    }, {
                        name: '主体结构',
                        code: '主体结构'
                    }, {
                        name: '钢结构',
                        code: '钢结构'
                    },
                    {
                        name: '装饰与屋面',
                        code: '装饰与屋面'
                    },
                        {
                        name: '其他',
                        code: '其他'
                     }

                ],

                installList32:[
                    {
                        name: '城市道路',
                        code: '城市道路'
                    }, {
                        name: '桥梁',
                        code: '桥梁'
                    }, {
                        name: '隧道',
                        code: '隧道'
                    },
                        {
                            name: '城市轨道交通',
                            code: '城市轨道交通'
                        },
                        {
                            name: '其他',
                            code: '其他'
                        }

                ],

                installList33:[
                    {
                        name: '给排水及采暖',
                        code: '给排水及采暖'
                    }, {
                        name: '通风与空调',
                        code: '通风与空调'
                    }, {
                        name: '电器装置及自动化',
                        code: '电器装置及自动化'
                    },

                    {
                        name: '其他',
                        code: '其他'
                    }

                ],



                installList3:[
                    {
                        name: '公路工程',
                        code: '公路工程'
                    }, {
                        name: '铁路工程',
                        code: '铁路工程'
                    }, {
                        name: '港口与航道工程',
                        code: '港口与航道工程'
                    },
                    {
                        name: '水利水电工程',
                        code: '水利水电工程'
                    },{
                        name: '电力工程',
                        code: '电力工程'
                    },{
                        name: '矿山工程',
                        code: '矿山工程'
                    },{
                        name: '冶金工程',
                        code: '冶金工程'
                    },{
                        name: '石油化工工程',
                        code: '石油化工工程'
                    },{
                        name: '通信工程',
                        code: '通信工程'
                    },

                ],
                oldAddList: [],

                form: {
                    company_name: '',
                    contacts_name: '',
                    contacts_post: '',
                    contacts_phone: '',
                    cellphone: '',
                    liability_ratio: '',
                    profit_rate: '',
                    growth_rate: '',
                },
                applicationForm:{}

            }
        },
        components: {
            labelInput,
            normalPicker,
            labelText,
            normalSelect
        },
        props: {
            // 切换基本信息和获奖信息
            isBasic: {
                type: Boolean,
                default: true
            },
            project_app_num: {
                type: String,
                default: ''
            },

            basicMsg: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            awardMsg: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        watch: {
            project_app_num(value){
                this.project_app_num2 = value
            },
            basicMsg(newvalue) {

                if(newvalue){
                    this.isEdit = 1
                    this.newform = {
                        ...newvalue
                    }

                    //this.completeManList = this.newform.complete_man
                    //this.applicationList = this.newform.project

                    if(this.newform.complete_man != '[]'){
                        this.completeManList      = this.newform.complete_man
                    }

                    console.log(999888777444);
                    console.log(this.newform.project);

                    if(this.newform.project != '[]'){

                        this.applicationList      = this.newform.project

                        this.fileList = []
                        this.applicationList.forEach((item, index) => {
                            this.fileList.push({
                                imgUrl:item.img
                            })
                        })

                    }

                    if(this.newform.patent != '[]'){
                        this.patentList      = this.newform.patent
                    }


                    this.project_app_num2      = this.newform.project_application_id



                }
            },

            awardMsg(newvalue) {

                console.log(4444)
                console.log(newvalue)
                console.log(8888)

                this.oldAddList = newvalue
            }
        },
        created() {
           // this.$emit('basicInfo', this.newform)
        },
        computed:{
           /* selectKey:function(){
                return (index)=>{
                    const oldValue = this.applicationForm
                    const newName = 'project_name'+index
                    const newValue =  oldValue[newName]
                    return this.applicationForm.project_name+String(index)
                }
            }*/
        },
        methods: {
            // 删除上传数据
            deleteUpload(index,index2) {
                this.fileList[index].imgUrl.splice(index2, 1)
            },
            handleRemove(e, fileList) {
                console.log(4343433443)
                console.log(fileList)
                console.log(e)
                this.fileList = fileList;
            },
            beforeAvatarUpload(file,index){

                console.log(8989898989898)
                console.log(file)

                const isJPG = file.type === "image/jpg";
                const isPng = file.type==="image/png";
                const isJpeg= file.type==="image/jpeg";
                const pdf= file.type==="application/pdf";

                //限制文件上传类型
                if (!isJPG && !isPng && !isJpeg && !pdf) {
                    this.$message.error("上传图片只能是 png,jpg,jpeg,pdf 格式!");
                    return false
                }


                let isLt2M
                if(file.type.indexOf('image')  != -1){
                    isLt2M = file.size / 1024 / 1024 < 10;
                    if (!isLt2M) {
                        this.$message.error('图片大小不能超过 10M !');
                        return false
                    }
                }else{
                    isLt2M = file.size / 1024 / 1024 < 50;
                    if (!isLt2M) {
                        this.$message.error('文件大小不能超过 50M !');
                        return false
                    }
                }

                this.uploadIndex = index
                return isLt2M;
            },

            httpRequest({file}) {

                console.log(6767677777777)

                const fileName = `项目申报/${Date.parse(new Date())}/${file.name}`; //定义唯一的文件名
                client.put(fileName, file).then(({res, url, name}) => {
                    if (res && res.status == 200) {
                        this.$message({
                            message: '上传成功',
                            type: 'success'
                        });
                        // console.log(`阿里云OSS上传文件成功回调`, res, url, name);

                        let ind = this.uploadIndex

                        console.log(7878787878)
                        console.log(ind)
                        console.log(url)
                        console.log(fileName)
                        console.log(file.name)

                       /* this.fileList[ind].url = url
                        this.fileList[ind].id = fileName
                        this.fileList[ind].name = file.name*/

                        console.log(this.fileList)
                        console.log(89898989898998)


                        this.fileList[ind].imgUrl.push({
                            url:url,
                            fileName:fileName,
                            name: file.name
                        })

                        console.log(this.fileList)
                        console.log(888888)


                    }
                }).catch((err) => {
                    console.log(`阿里云OSS上传失败回调`, err);
                });
            },


            //上传前
            beforeUpload(file) {


            },

            // 获取必填警示
            requireSubmit(params, nameList) {
                //如果数据是对象形式
                let upString = []
                Object.keys(params).forEach((item, index) => {
                    if (params[item] == '' || params[item] == undefined || params[item] == null) {
                        if (nameList[item]) {
                            upString.push(item)
                        }
                    }
                })
                if (!upString.length) {
                    return false
                } else {
                    this.$message.error(`${nameList[upString[0]]}未填写`)
                    return true
                }
                // 如果数据是数组形式
            },

            // 基本信息申报
            async basicInfo() {
                const params = {
                    ...this.levelOne
                }

                // 验证各个工程的表单

                console.log(params)

                if (this.requireSubmit(params, this.formName)) {
                    return
                }

                console.log(this.completeManList)
                console.log(this.applicationList)
                console.log(this.patentList)
                console.log(this.fileList)
                console.log(this.basicMsg)

                console.log(666777888999)
                //return  false

                if(this.fileList.length != this.applicationList.length){

                    this.$message.error("工程照片未传")

                    return false

                }



                await setAdvanceInfoGF({
                    data: {
                        newform : this.newform,
                        completeManList : this.completeManList,
                        applicationList : this.applicationList,
                        patentList : this.patentList,
                        fileList : this.fileList,
                        project_code : this.basicMsg.project_code,
                        project_app_num : this.project_app_num2
                    },
                    success: res => {
                        if (res.code === 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            this.project_app_num2 = res.data.project_app_num
                            this.$emit('basicInfo', res.data.project_app_num)
                        } else {

                            this.$message.error(res.msg)
                        }
                    }
                })

            },

            // 提交获奖信息
            async getWinninginfo() {

                const params = {
                    ...this.levelOne
                }

                if (this.project_app_num2) {
                    params.project_app_num = this.project_app_num2
                }

                let newAddList = [...this.addList, ...this.oldAddList]
                for (let item in newAddList) {
                    if (!newAddList[item].qualification_category || !newAddList[item].qualification_level) {
                        this.$message.error('未填写完整')
                        return
                    }
                }

                params.awardJson = newAddList

                await saveQua({
                    data: params,
                    success: res => {
                        if (res.code === 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            //this.project_app_num = res.data.project_app_num
                        } else {
                            // this.project_app_num = res.data.project_app_num
                            this.$message.error(res.msg)
                        }
                    }
                })

            },

            typeThreeInput2(e, type, index) {

                console.log("开始了")
                console.log(e)


                console.log('typeThreeInput2',e)
                if (type == '1') {

                    this.applicationList[index].project_name = e

                } else if(type == '2'){

                    this.applicationList[index].start_work = e

                }
            },

            typeThreeInput4(e, type, index) {
                if (type == '1') {

                    this.patentList[index].patent_name = e

                } else if(type == '2'){

                    this.patentList[index].patent_num = e

                }else if(type == '3'){

                    this.patentList[index].patent_man_name = e

                }else if(type == '4'){

                    this.patentList[index].range = e

                }
            },


            typeThreeInput1(e, type, index) {
                if (type == '1') {

                    this.completeManList[index].username = e

                } else if(type == '2'){

                    this.completeManList[index].unit = e

                } else if(type == '3'){

                    this.completeManList[index].post = e

                }else if(type == '4'){

                    this.completeManList[index].title = e

                }else if(type == '5'){

                    this.completeManList[index].phone = e

                }
            },

            // 新增参建单位输入
            typeThreeInput(e, type,index = '') {
                if (type == '1') {

                    console.log(e)

                    if(e == '房屋建筑工程'){

                        this.installList35 =  this.installList31
                    }else if(e == '市政公用工程'){

                        this.installList35 =  this.installList32
                    }else if(e == '机电安装工程'){

                        this.installList35 =  this.installList33
                    }else{

                        this.installList35 =  this.installList3
                    }

                    this.newform.category = e

                    if(this.isEdit !=1){
                        this.newform.major_category = ''
                    }

                } else if(type == '2'){
                    this.newform.major_category = e
                }else if(type == '3'){
                    this.newform.recommend_area = e
                }else if(type == '4'){
                    this.newform.register_area = e
                }else if(type == '5'){
                    this.newform.is_pro = e
                }else if(type == '6'){
                    this.newform.has_patent = e
                }else if(type == '11'){
                    this.applicationList[index].where = e

                }else if(type == '12'){
                    this.patentList[index].patent_enp = e
                }
            },
            // 新增参建单位
            addInstall() {
                this.addList.push({})
            },

            addInstall1(){

                if(this.completeManList.length >=5){
                    this.$message.error(`最多5个哦`)
                    return
                }

                this.completeManList.push({})


            },

            deleteList1(){

                if(this.completeManList.length-1 >= 0 ){

                    this.completeManList.splice(this.completeManList.length-1, 1)

                }

            },

            addInstall2(){
                this.applicationList.push({})

                this.fileList.push({
                          imgUrl:[]
                      })
            },

            deleteList2(){
                if(this.applicationList.length-1 >= 0 ){
                    this.applicationList.splice(this.applicationList.length-1, 1)

                    this.fileList.splice(this.fileList.length-1, 1)
                }


            },

            addInstall3(){
                this.patentList.push({})
            },

            deleteList3(){

                if(this.patentList.length-1 >= 0 ){
                    this.patentList.splice(this.patentList.length-1, 1)
                }

            },

            // 删除行
            deleteList(index, type) {
                const number = this.addList.length + this.oldAddList.length
                if (number === 1) {
                    this.$message.error(`至少填写一条参建信息`)
                    return
                }
                if (type === '1') {
                    // 例旧信息
                    this.oldAddList.splice(index, 1)
                } else {
                    this.addList.splice(index, 1)
                }

            },

            labelInput(e, name) {
                this.newform[name] = e
               // this.$emit('basicInfo', this.form)
            },
            labelInput2(e, name, id) {
                const params = [id, name, e]
                this.$emit('awardInfo', params)
            }
        }
    }
</script>

<style scoped>
    .midflex {
        width: 100%;
        text-align: center;
        margin-bottom: 20px;
    }

    /* 每个上传文件的样式 */
    .inner_upload {
        position: relative;
        min-height: 40px;
        margin: 0 10px;
        /* width: 100px; */
        /* overflow: scroll; */
    }

    .inner_upload p {
        color: #1890FF;
    }

    .inner_upload img {
        border-radius: 50%;
        position: absolute;
        right: -16px;
        top: 0;
        width: 15px;
        height: 15px;
        cursor: pointer;
    }

    .inputList {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
    }

    .view_head {
        font-size: 18px;
        font-weight: 600;
        margin-top: 20px;
    }

    .titleLeft {
        margin-left: 50px;
    }

    .awardInfo {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
    }

    /* 提示 */
    .allTips {
        margin: 20px 0;
        padding-left: 80px;
        text-align: left;
    }

    .tipList {
        /* margin-left: 80px; */
        display: flex;
        justify-content: flex-start;
    }

    .tipList p {
        display: inline-block;
        text-align: left;
        line-height: 25px;
    }

    .tipList p:nth-child(1) {
        width: 80px;
    }

    .tipList p:nth-child(2) {
        width: 200px;
    }

    .tipList p:nth-child(3) {
        width: 350px;
    }
</style>
